import CreditLimitCard from "./Cards/CreditLimitCard";
import FiltersCard from "./Cards/FiltersCard";
import TerminalInformationCard from "./Cards/TerminalInformationCard";

const terminalData = {
	linkId: "898709924412686157",
	msisdn: "870772188070",
	client: "Al JAZEERA ARABIC",
	provider: "INMARSAT DP",
	simType: "Postpaid",
	staticIp: "None",
	ipAddress: "10.252.1.32",
	range: "10.252.0.0/ 16",
	lastUsageDate: "N/A",
	connectionStatus: "Online",
	connectionDate: "2026-09-03 09:15:12",
	creationStatus: "Created",
	simcardStatus: "Active",
	usageSummary: "BACKGROUND_IP",
};

const filtersData = [
	{
		id: "test-1",
		name: "TEST 1",
		description: "This filter block youtube.com facebook.com netflix.com vimeo.com twitter",
		status: "Created",
		enabled: true,
	},
	{
		id: "tesrt-2",
		name: "TEST 2",
		description:
			"A set of advanced filtration for restricted usage and prioritization of corporate approved applications",
		status: null,
		enabled: false,
	},
];
const monthlyAlerts = [];
const yearlyAlerts = [];

const creditlimitData = {
	allowanceValue: 1023.0,
	allowanceCurrentValue: 129.4,
	limitValue: 200.0,
	limitCurrentValue: 0.0,
	extensions: [],
	cycleDuration: "1 Month",
	nextReplenishDate: "2026-10-01",
	threshold50PercentInBundle: false,
	disconnect100PercentOutOfBundle: false,
};

const InmarsatDp = () => {
	return (
		<>
			<div className="grid gap-4 p-4">
				<div className="grid grid-cols-1">
					<CreditLimitCard data={creditlimitData} />
				</div>
				<div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
					<TerminalInformationCard data={terminalData} />
					<FiltersCard filters={filtersData} />

				</div>
			</div>
		</>
	);
};

export default InmarsatDp;
